(function($) {

  /*
    This JS scrolls the page on the anchors in order to avoid the page goes to the top everytime.
  */

  var $tabs = $('.c-tablist__tabs a');


  $tabs.on( "click", function(e) {
    // console.log($(this).text());    
    // e.preventDefault();

    // $('html,body').animate({
    //   scrollTop: $(this).offset().top - 10
    // }, 500);    

  });

})(jQuery);